import { ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pt-4 lg:pt-8">
      <div className="lg:col-span-7 space-y-6">
        <span
          data-testid="hero-tagline"
          className="inline-block nb-border bg-[#FCD34D] px-3 py-1 text-xs font-black uppercase tracking-wider"
        >
          Pour parents épuisés de devoir se justifier
        </span>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
          La réplique parfaite
          <br />
          <span className="bg-[#FF4D85] nb-border inline-block px-3 py-1 rotate-[-2deg] mt-2">
            au conseil
          </span>{" "}
          <span className="bg-[#A7F3D0] nb-border inline-block px-3 py-1 rotate-[1deg]">
            non sollicité
          </span>
        </h1>
        <p className="text-lg sm:text-xl font-medium max-w-xl">
          Belle-mère qui sait mieux ? Voisin qui s'invite dans vos choix ? Collez la
          phrase, choisissez le ton, recevez 3 répliques.{" "}
          <span className="bg-[#FCD34D] px-1 font-extrabold">Vous reprenez le contrôle.</span>
        </p>
        <div className="flex flex-wrap items-center gap-3 pt-2">
          <a
            href="#generator"
            data-testid="hero-cta"
            className="nb-border bg-[#FF4D85] text-[#0A0A0A] px-6 py-3 font-extrabold nb-shadow hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[6px_6px_0_0_#0A0A0A] active:translate-x-0 active:translate-y-0 active:nb-shadow transition-all inline-flex items-center gap-2"
          >
            Trouver ma réponse <ArrowDown size={18} strokeWidth={3} />
          </a>
          <a
            href="#categories"
            data-testid="hero-secondary"
            className="nb-border bg-white px-6 py-3 font-extrabold hover:bg-[#F3F4F6] transition-colors"
          >
            Voir les classiques
          </a>
        </div>
      </div>

      <div className="lg:col-span-5">
        <div className="relative">
          <div className="nb-border bg-white p-3 nb-shadow-lg rotate-[1deg]">
            <img
              src="https://images.pexels.com/photos/4474029/pexels-photo-4474029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Parent débordé avec sourire complice"
              className="w-full h-[280px] sm:h-[360px] object-cover contrast-110 saturate-[0.85]"
            />
          </div>
          <div className="absolute -top-4 -left-4 nb-border bg-[#FCD34D] px-3 py-2 font-black text-sm rotate-[-6deg]">
            « Tu devrais le laisser pleurer ! »
          </div>
          <div className="absolute -bottom-4 -right-2 nb-border bg-[#A7F3D0] px-3 py-2 font-black text-sm rotate-[5deg]">
            → 3 répliques en 2 sec
          </div>
        </div>
      </div>
    </section>
  );
}
